export default "__VITE_ASSET__D3bGL9kD__"